import SwiperSlider from "./module/SwiperSlider";
import AccordianHandler from "./module/AccordianHandler";
import customAccordianHandler from "./module/CustomAccordianHandler";

import NavbarToggler from "./module/NavbarToggler";
import TabsHandler from "./module/TabsHandler";
import PageLoader from "./module/PageLoader";
import FontResizerController from "./module/FontResizerController";
import SVGConverter from "./module/SVGConverter";
import ResponsiveHandler from "./module/ResponsiveHandler";
import StickyHeader from "./module/StickyHeader";
import ShowHide from "./module/ShowHide";

// Generic Slider Module Create slider which contains the class swiper.
const swiperSliders = document.querySelectorAll(".swiper");
swiperSliders.forEach((item) => new SwiperSlider(item));
const footerMobileMenu = new AccordianHandler(".toggle-btn");
const accordion = new customAccordianHandler(".faq_header");
const navbarToggler = new NavbarToggler("#toggle", ".navigation");
const pageLoader = new PageLoader();
const desktopResponsive = new FontResizerController();
const svgConverterInstance = new SVGConverter();
const mobileLandscapeOff = new ResponsiveHandler();
const stickyHeader = new StickyHeader(".header");
const showHideSearchBar = new ShowHide(".search-wrapper", ".cross-icon");
const tabsHandler = new TabsHandler(".generic-tabs li", ".news_listing_data");
const showpoupform = new ShowHide(".career_popup", ".close_btn");

document.querySelectorAll(".mobileToggle").forEach((toggle) => {
  toggle.addEventListener("click", function () {
    // Remove active class and max-height from all other toggles and menus
    document.querySelectorAll(".mobileToggle").forEach((item) => {
      if (item !== this) {
        item.classList.remove("active");
        const innerMenu = item.parentElement.querySelector(".inner-menu");
        if (innerMenu) {
          innerMenu.style.maxHeight = null;
        }
        item.parentElement.classList.remove("opened");
      }
    });

    // Toggle active class on the clicked toggle
    this.classList.toggle("active");

    // Get the `.inner-menu` element relative to the clicked toggle
    const innerMenu = this.parentElement.querySelector(".inner-menu");
    if (innerMenu) {
      if (innerMenu.style.maxHeight) {
        innerMenu.style.maxHeight = null; // Collapse the menu
        this.parentElement.classList.remove("opened");
      } else {
        innerMenu.style.maxHeight = innerMenu.scrollHeight + "px"; // Expand the menu
        this.parentElement.classList.toggle("opened");
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const menuBtn = document.querySelector(".menu-btn");
  const megaMenu = document.querySelector(".mega-menu");
  const icon = menuBtn.querySelector(".icon svg"); // Target the SVG inside .icon
  const html = document.documentElement; // Select the <html> tag

  if (menuBtn && megaMenu && icon) {
    menuBtn.addEventListener("click", () => {
      // Toggle 'active' class on menu-btn
      menuBtn.classList.toggle("active");

      // Toggle 'open' class on mega-menu
      megaMenu.classList.toggle("open");

      // Toggle 'overflow-hidden' class on <html>
      html.classList.toggle("overflow-hidden");

      // Update SVG based on active state
      if (menuBtn.classList.contains("active")) {
        icon.innerHTML = `
          <path d="M1 1L14 14" stroke="#183B62" stroke-width="2"></path>
          <path d="M14 1L1 14" stroke="#183B62" stroke-width="2"></path>
        `;
        icon.setAttribute("viewBox", "0 0 15 15"); // Update viewBox for cross icon
      } else {
        icon.innerHTML = `
          <path d="M4.73353 0H0V4.36978H4.73353V0Z" fill="#183B62"></path>
          <path d="M15 0H10.2665V4.36978H15V0Z" fill="#183B62"></path>
          <path d="M4.73353 9.47637H0V13.8462H4.73353V9.47637Z" fill="#183B62"></path>
          <path d="M15 9.47637H10.2665V13.8462H15V9.47637Z" fill="#183B62"></path>
        `;
        icon.setAttribute("viewBox", "0 0 15 14"); // Reset viewBox for original icon
      }
    });
  }
});

document.querySelectorAll(".mobileToggle").forEach((toggle) => {
  toggle.addEventListener("click", function () {
    // Check if the toggle is inside a container with the class 'mega-inner'
    if (this.closest(".mega-inner")) {
      // Remove active class and max-height from all other toggles and menus
      document.querySelectorAll(".mobileToggle").forEach((item) => {
        if (item !== this) {
          item.classList.remove("active");
          const innerMenu = item.nextElementSibling;
          if (innerMenu) {
            innerMenu.style.maxHeight = null;
          }
        }
      });

      // Toggle active class on the clicked toggle
      this.classList.toggle("active");

      // Toggle max-height of the next sibling (inner-menu)
      const innerMenu = this.nextElementSibling;
      if (innerMenu) {
        if (innerMenu.style.maxHeight) {
          innerMenu.style.maxHeight = null; // Collapse the menu
          innerMenu.parentNode.classList.remove("opened");
        } else {
          innerMenu.style.maxHeight = innerMenu.scrollHeight + "px"; // Expand the menu
          innerMenu.parentNode.classList.add("opened");
        }
      }
    }
  });
});

if (document.querySelector(".core_foundation_sec")) {
  document.addEventListener("DOMContentLoaded", function () {
    const titles = document.querySelectorAll(".core_title_wrapper");
    const images = document.querySelectorAll(".coreimg_card_Wrapper");
    const defaultIndex = 0; // Default active index

    function setActive(index) {
      // Remove active class from all
      titles.forEach((t) => t.classList.remove("active"));
      images.forEach((img) => img.classList.remove("active"));

      // Add active class to the selected element
      titles[index].classList.add("active");
      images[index].classList.add("active");
    }

    // Set the first item as active by default
    setActive(defaultIndex);

    titles.forEach((title) => {
      title.addEventListener("mouseover", function () {
        let index = this.getAttribute("data-index");
        setActive(index);
      });
    });

    // Reset to first item when mouse leaves the container
    document
      .querySelector(".left_col")
      .addEventListener("mouseleave", function () {
        setActive(defaultIndex);
      });
  });
}

// if (document.querySelector(".career_popup")) {
//   document.addEventListener("DOMContentLoaded", () => {
//     const careerPopupBtns = document.querySelectorAll(".career_popup");
//     const popupWrapper = document.querySelector(".popup_wrapper");
//     const closeBtn = document.querySelector(".close_btn");
//     const html = document.documentElement; // Select the <html> tag

//     careerPopupBtns.forEach((btn) => {
//       btn.addEventListener("click", () => {
//         popupWrapper.classList.add("active");
//         html.classList.add("overflow-hidden"); // Disable scrolling
//       });
//     });

//     const closePopup = () => {
//       popupWrapper.classList.remove("active");
//       html.classList.remove("overflow-hidden"); // Enable scrolling
//     };

//     closeBtn.addEventListener("click", closePopup);

//     popupWrapper.addEventListener("click", (event) => {
//       if (event.target === popupWrapper) {
//         closePopup();
//       }
//     });
//   });
// }



function addSingleIFrames() {
  let iframeDataElements = document.querySelectorAll(".iframedataa");

  iframeDataElements.forEach((iframeDataElement) => {
    let dsrc1 = iframeDataElement.getAttribute("data-src");

    if (dsrc1) {
      let iFrame1 = `<iframe class="iframeVidz" src="${dsrc1}" style=""></iframe>`;

      setTimeout(() => {
        iframeDataElement.innerHTML = iFrame1;
      }, 500);
    }
  });
}

// Function Call
addSingleIFrames();

var fecthMasonry = function (container, items, columns) {
  var CONTAINER_EL = document.querySelector("#" + container);
  if (!CONTAINER_EL) return;

  var WRAPPER_CONTAINER_EL = CONTAINER_EL.parentNode;
  var ITEMS_ELS = document.querySelectorAll("." + items);
  CONTAINER_EL.parentNode.removeChild(CONTAINER_EL);
  var NEW_CONTAINER_EL = document.createElement("div");
  NEW_CONTAINER_EL.setAttribute("id", container);
  NEW_CONTAINER_EL.classList.add("masonry-layout", "columns-" + columns);
  WRAPPER_CONTAINER_EL.appendChild(NEW_CONTAINER_EL);

  // Create columns
  for (var i = 1; i <= columns; i++) {
    var COLUMN = document.createElement("div");
    COLUMN.classList.add("masonry-column-" + i);
    NEW_CONTAINER_EL.appendChild(COLUMN);
  }

  // Distribution count for each column
  var distribution = {
    1: 3, // column 1 gets 3 images
    2: 2, // column 2 gets 2 images
    3: 2, // column 3 gets 2 images
    4: 3, // column 4 gets 3 images
  };

  // Keep track of added items per column
  var columnCounts = { 1: 0, 2: 0, 3: 0, 4: 0 };
  var itemsProcessed = 0;

  // First pass: distribute items according to our desired distribution
  ITEMS_ELS.forEach(function (item) {
    // Find the next column that needs items
    for (var colNum = 1; colNum <= columns; colNum++) {
      if (columnCounts[colNum] < distribution[colNum]) {
        var col = document.querySelector(
          "#" + container + " > .masonry-column-" + colNum
        );
        col.appendChild(item);
        columnCounts[colNum]++;
        itemsProcessed++;
        break;
      }
    }

    // If we've placed all our specified distribution, exit the loop
    if (itemsProcessed >= ITEMS_ELS.length) {
      return;
    }
  });

  // Second pass: if there are any remaining items, distribute them evenly
  if (itemsProcessed < ITEMS_ELS.length) {
    var remainingItems = Array.from(ITEMS_ELS).slice(itemsProcessed);
    var currentCol = 1;

    remainingItems.forEach(function (item) {
      var col = document.querySelector(
        "#" + container + " > .masonry-column-" + currentCol
      );
      col.appendChild(item);
      currentCol = (currentCol % columns) + 1;
    });
  }
};

// Initialize masonry layout only if viewport is wider than 576px
function initMasonryIfDesktop() {
  if (window.innerWidth > 576) {
    fecthMasonry("masonry", "image", 4);
  } else {
    // For mobile, revert to normal flow if masonry was already applied
    const masonryContainer = document.querySelector("#masonry");
    if (masonryContainer && masonryContainer.classList.contains("masonry-layout")) {
      const items = document.querySelectorAll(".image");
      const parent = masonryContainer.parentNode;

      // Create a new container without masonry layout
      const newContainer = document.createElement("div");
      newContainer.setAttribute("id", "masonry");

      // Move all items to the new container
      items.forEach(item => {
        newContainer.appendChild(item);
      });

      // Replace the old container
      parent.removeChild(masonryContainer);
      parent.appendChild(newContainer);
    }
  }
}

// Run on load
initMasonryIfDesktop();

// Re-run on resize
window.addEventListener('resize', initMasonryIfDesktop);





// Function to handle file input change event
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var inputFile = document.getElementById("cv-upload");
    console.log("inputfile", inputFile);
    if (inputFile) {
      var label = document.querySelector('label[for="cv-upload"]');
      if (label) {
        var defaultLabel = label.querySelector("span").innerHTML;
        console.log("Default label text:", defaultLabel);
        inputFile.addEventListener("change", function (e) {
          var fileName = "";
          if (this.files && this.files.length > 0) {
            fileName = this.files[0].name;
          } else {
          }
          if (fileName) {
            label.querySelector("span").innerHTML = fileName;
          } else {
            label.querySelector("span").innerHTML = defaultLabel;
          }
        });
      } else {
        // console.error("Label not found for input file.");
      }
    } else {
      // console.error("Input file element not found.");
    }
  });
})();